import { render, staticRenderFns } from "./_navbarMenu.vue?vue&type=template&id=8f12afe2"
import script from "./_navbarMenu.vue?vue&type=script&lang=js"
export * from "./_navbarMenu.vue?vue&type=script&lang=js"
import style0 from "./_navbarMenu.vue?vue&type=style&index=0&id=8f12afe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports